import { ChangeEvent, FC } from "react";
import { Form } from "react-bootstrap";
import { PiCheckCircleBold, PiXCircleBold } from "react-icons/pi";
import FlexBox from "./flex-box";

interface SimpleSwitchProps {
  isShowIcons?: boolean;
  isDisabled?: boolean;
  yesIcon?: JSX.Element;
  noIcon?: JSX.Element;
  name: string;
  label?: string;
  value: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

const SimpleSwitch: FC<SimpleSwitchProps> = ({
  isShowIcons = true,
  isDisabled = false,
  value,
  onChange,
  name,
  label = "Switch",
  yesIcon = <PiCheckCircleBold size={20} fill="green" />,
  noIcon = <PiXCircleBold size={20} fill="red" />,
}) => {
  return (
    <FlexBox justifyContent="start" alignItems="center" className="mb-3">
      {isShowIcons && <>{value ? yesIcon : noIcon}</>}

      <Form.Check
        type="switch"
        name={name}
        id={name}
        checked={value}
        onChange={onChange}
        label={label}
        disabled={isDisabled}
      />
    </FlexBox>
  );
};

export default SimpleSwitch;
